import styled from "styled-components/macro";

export const AvatarHeaderDiv = styled.div`
  max-width: 98%;
  width: 100%;
  margin: 0 auto;
  height: 70px;

  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 750px) {
    max-width: 95%;
  }
`;

export const AvatarHeaderDiv_Image = styled.div`
  height: 100%;
  width: 50%;
  padding-bottom: 12px;
  padding-top: 5px;
  display: flex;
  justify-content: center;

  @media (min-width: 415px) {
    width: 100%;
    justify-content: flex-start;
  }

  .imageCompanyLogo {
    width: 100%;
    object-fit: contain;

    @media (min-width: 750px) {
      width: 100%;
    }
  }

  .providerCompanyLogo {
    object-fit: contain;
    display: block;
    height: 100%;
    width: 100%;
  }
`;

export const NameDiv = styled.div`
  height: 100%;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;

  @media (min-width: 415px) {
    width: 100%;
    gap: 1%;
    justify-content: flex-end;
  }

  .spanDivs {
    display: none;

    @media (min-width: 500px) {
      display: flex;
      flex-direction: column;

      align-items: flex-end;
    }
  }

  .bellIConDiv .bellICon {
    font-size: 15px;

    @media (min-width: 750px) {
      font-size: 22px;
    }
  }

  .name {
    font-size: 0.85rem;

    @media (min-width: 750px) {
      font-size: 1.15rem;
    }
  }
`;

// className="d-flex justify-content-between align-items-center"
